import { browser } from '$app/environment';
import type { TVersion } from '$src/lib/services/device/types';
import { compareVersion } from '$src/lib/services/device/utils';
import {
    isAndroidNative,
    isIOSNative
} from '$src/routes/(noshell)/[[market=isMarket]]/register/deviceTracker/deviceTracker';

let shouldShow: boolean;
const versionRegex = /(?<version>\d+\.\d+\.\d+)/;

export function showSomeElementsForNewerAppVersions(): boolean {
    if (!browser) return true;

    if (shouldShow !== undefined) return shouldShow;

    if (!window.native) {
        shouldShow = true;
    } else {
        const appVersion = window.native.version?.match(versionRegex)?.groups?.version as TVersion;
        shouldShow =
            !appVersion ||
            (isIOSNative() && compareVersion(appVersion, '2.54.2') === 1) ||
            (isAndroidNative() && compareVersion(appVersion, '2.9.4') === 1);
    }

    return shouldShow;
}
